import Vue from 'vue'
import VueRouter from 'vue-router'
import routers from './router/routers'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import * as echarts from 'echarts'
import App from './App.vue'
import store from './store'
import {
  post,
  get,
  getTwo
} from './router/request.js'
import {createSocket} from './router/websocket.js'
import axios from 'axios'
import VueAxios from "vue-axios";

//引入echarts
//定义全局变量
Vue.prototype.$createSocket = createSocket;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$getTwo = getTwo;
Vue.prototype.$store = store;


Vue.prototype.$echarts = echarts;
Vue.use(ElementUI)
// Vue.use(echarts)
Vue.use(VueRouter)
Vue.use(VueAxios, axios)


const router = new VueRouter({
  mode: 'history',
  routes: routers
})

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js